// 获取官网版本信息
export default {
  getVersion: {
    url: "/acs-fxk-config/v2/web/version",
    method: "POST"
  },
  getContactInfo: {
    url: "/szjy-science-edu-center/course/v1/getContactInfo",
    method: "POST"
  }
};